import type { SignInFlowError } from '../../hooks/classify-auth-error';
import { AuthErrorMessage } from './AuthErrorMessage';

interface SignInCompletionFailureProps {
  error: SignInFlowError;
  submitting: boolean;
  onRetry: () => void;
}

/**
 * サインインは完了したが、その後の処理（デスクトップへのトークン受け渡し・認証状態の更新）に
 * 失敗したときの表示。サインインからやり直さず、後処理だけをもう一度試せるようにする。
 */
export function SignInCompletionFailure({
  error,
  submitting,
  onRetry,
}: SignInCompletionFailureProps) {
  return (
    <div className="space-y-6">
      <AuthErrorMessage error={error} />
      <button
        type="button"
        onClick={onRetry}
        disabled={submitting}
        className="w-full py-3 px-4 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {submitting ? '処理中...' : 'もう一度試す'}
      </button>
    </div>
  );
}
